import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'portal',
        loadChildren: () => import('./portal/portal.module').then((m) => m.PortalModule),
        data: {
          title: 'Adspert Login',
          preload: false,
          isFluid: false,
        },
      },
      {
        path: 'signup',
        loadChildren: () => import('./signup/signup.module').then((m) => m.SignupModule),
        data: {
          title: 'Adspert Signup',
          preload: false,
          isFluid: false,
        },
      },
      {
        path: 'oauth',
        loadChildren: () => import('./oauth-flow/oauth-flow.module').then((m) => m.OauthFlowModule),
        data: {
          title: 'Renew Account Access',
          preload: false,
          isFluid: false,
        },
      },
      {
        path: 'billed-usage-report',
        loadChildren: () =>
          import('./billed-usage-reports/billed-usage-reports.module').then((m) => m.BilledUsageReportModule),
        data: {
          title: 'Usage Report',
          preload: false,
          isFluid: false,
        },
      },
      {
        path: '',
        loadChildren: () => import('./client/client.module').then((m) => m.ClientModule),
        data: {
          title: 'Adspert',
          preload: false,
          isFluid: false,
        },
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class RootRoutingModule {}
